/*
 * Returns the Dropdown Styles
 *
 * @returns {Styles}
 */

const colorStateHandler = (state) => {
	if (state.isDisabled) {
		return '#e4e5e8';
	} else if (state.isFocused) {
		return '#48bfa2';
	} else if (state.isSelected) {
		return '#484952';
	} else {
		return '#484952';
	}
};
const customStyles = {
	container: (provided, state) => ({
		fontFamily: 'Proxima N W01 Smbd',
		fontWeight: 'normal',
		fontSize: '1.6rem',
		lineHeight: '1.4375',
		opacity: state.isDisabled ? 0.7 : 1,
	}),
	control: (provided, state) => ({
		alignItems: 'center',
		backgroundColor: 'rgb(255, 255, 255)',
		cursor: 'default',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		minHeight: '38px',
		position: 'relative',
		boxSizing: 'border-box',
		borderRadius: '4px',
		borderColor: '#fff',
		borderStyle: 'solid',
		borderWidth: '2px',
		transition: 'all 100ms ease 0s',
		outline: '0px !important',
		borderBottomRightRadius: state.isFocused ? '0' : '4px',
		borderBottomLeftRadius: state.isFocused ? '0' : '4px',
		'&:hover': {
			boxShadow: '0 0 15px rgba(0,0,0,0.4)',
		},
	}),
	dropdownIndicator: (provided, state) => ({
		backgroundColor: '#48bfa2',
		padding: '0 12px',
		boxSizing: 'border-box',
		cursor: 'pointer',
		display: 'flex',
		flexFlow: 'row nowrap',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
		textAlign: 'center',
		verticalAlign: 'middle',
		width: '44px',
		height: '100%',
	}),
	indicatorSeparator: () => ({
		// none of react-select's styles are passed to <IndicatorSeparator />
	}),
	valueContainer: () => ({
		boxSizing: 'border-box',
		color: '#60616d',
		paddingLeft: '10px',
		paddingRight: '10px',
	}),
	option: (provided, state) => ({
		...provided,
		boxSizing: 'border-box',
		backgroundColor: '#fff',
		color: colorStateHandler(state),
		cursor: state.isDisabled ? 'default' : 'pointer',
		display: 'block',
		padding: '6px 10px',
		'&:last-child': {
			borderBottomRightRadius: '4px',
			borderBottomLeftRadius: '4px',
		},
	}),
	menu: () => ({
		borderBottomRightRadius: '4px',
		borderBottomLeftRadius: '4px',
		backgroundColor: '#fff',
		border: '1px solid #fff',
		boxShadow: '0 0 15px rgba(0,0,0,0.4)',
		boxSizing: 'border-box',
		marginTop: '-4px',
		maxHeight: '300px',
		position: 'absolute',
		top: '100%',
		width: '100%',
		zIndex: 1,
	}),
};

export default customStyles;
